import { useMediaQuery } from "react-responsive";

export const useMedia = () => {
  const isMedium = useMediaQuery({ query: "(min-width: 690px)" });
  const isDesktop = useMediaQuery({ query: "(min-width: 1000px)" });

  if (!isMedium && !isDesktop) return "small";
  if (isDesktop) return "desktop";
  return "medium";
};
